import { defineStore } from 'pinia'

export const useOverlayStore = defineStore('overlay', () => {
  const loader = ref(false)
  const mobileMenu = ref(false)

  // Reset all overlays to false
  function reset() {
    loader.value = false
    mobileMenu.value = false
  }

  // Either toggle or set the loader overlay to a specific value
  function setLoader(show?: boolean) {
    loader.value = show === undefined ? !loader.value : show
    mobileMenu.value = false
  }

  // Either toggle or set the mobileMenu overlay to a specific value
  function setMobileMenu(show?: boolean) {
    loader.value = false
    mobileMenu.value = show === undefined ? !mobileMenu.value : show
  }

  return { loader, mobileMenu, reset, setLoader, setMobileMenu }
})
